<div class="unauthorized-container">
    <div class="unauthorized-message">
      <h1 class="unauthorized-title">Access Denied</h1>
      <p class="unauthorized-text">
        You do not have permission to access this resource.
      </p>
      <button class="btn-redirect" (click)="redirectToLogin()">Go to Login</button>
    </div>
  </div>
  